import { apiClient } from './api';

export const incidentApi = {
  // Get all incidents with filtering
  getIncidents: async (filters = {}) => {
    const params = {};
    if (filters.status) params.status = filters.status;
    if (filters.priority) params.priority = filters.priority;
    if (filters.category) params.category = filters.category;
    if (filters.assigned_to) params.assigned_to = filters.assigned_to;
    if (filters.limit) params.limit = filters.limit;
    
    const response = await apiClient.get('/incidents', { params });
    return response.data;
  },

  // Get incident statistics
  getIncidentStats: async () => {
    const response = await apiClient.get('/incidents/stats');
    return response.data;
  },

  // Get incident by ID
  getIncident: async (incidentId) => {
    const response = await apiClient.get(`/incidents/${incidentId}`);
    return response.data;
  },

  // Create a new incident
  createIncident: async (incident) => {
    const response = await apiClient.post('/incidents', incident);
    return response.data;
  },

  // Update incident
  updateIncident: async (incidentId, updates) => {
    const response = await apiClient.put(`/incidents/${incidentId}`, updates);
    return response.data;
  },

  // Assign AI agent to incident
  assignAIAgent: async (incidentId) => {
    const response = await apiClient.post(`/incidents/${incidentId}/assign-ai-agent`);
    return response.data;
  },

  // Get AI recommendations for incident
  getRecommendations: async (incidentId) => {
    const response = await apiClient.get(`/incidents/${incidentId}/recommendations`);
    return response.data;
  },

  // Validate AI recommendation
  validateRecommendation: async (recommendationId, validated, feedback = null) => {
    const response = await apiClient.post(`/recommendations/${recommendationId}/validate`, {
      validated,
      feedback
    }, {
      params: { validated, feedback }
    });
    return response.data;
  },

  // Mark recommendation as implemented
  implementRecommendation: async (recommendationId) => {
    const response = await apiClient.post(`/recommendations/${recommendationId}/implement`);
    return response.data;
  },

  // Create mock data for testing
  createMockIncidents: async () => {
    const response = await apiClient.post('/mock-data/incidents');
    return response.data;
  }
};

export const ragApi = {
  // Get knowledge bases
  getKnowledgeBases: async (category = null) => {
    const params = category ? { category } : {};
    const response = await apiClient.get('/knowledge-bases', { params });
    return response.data;
  },

  // Create knowledge base
  createKnowledgeBase: async (knowledgeBase) => {
    const response = await apiClient.post('/knowledge-bases', knowledgeBase);
    return response.data;
  },

  // Get RAG agents
  getRAGAgents: async () => {
    const response = await apiClient.get('/rag-agents');
    return response.data;
  },

  // Create RAG agent
  createRAGAgent: async (agent) => {
    const response = await apiClient.post('/rag-agents', agent);
    return response.data;
  },

  // Create mock knowledge bases
  createMockKnowledgeBases: async () => {
    const response = await apiClient.post('/mock-data/knowledge-bases');
    return response.data;
  },

  // Create mock RAG agents
  createMockRAGAgents: async () => {
    const response = await apiClient.post('/mock-data/rag-agents');
    return response.data;
  },

  // Get knowledge base details
  getKnowledgeBaseDetails: async (kbId) => {
    const response = await apiClient.get(`/knowledge-bases/${kbId}`);
    return response.data;
  },

  // Update knowledge base
  updateKnowledgeBase: async (kbId, updates) => {
    const response = await apiClient.put(`/knowledge-bases/${kbId}`, updates);
    return response.data;
  },

  // Add procedure to knowledge base
  addProcedureToKnowledgeBase: async (kbId, procedure) => {
    const response = await apiClient.post(`/knowledge-bases/${kbId}/procedures`, procedure);
    return response.data;
  },

  // Get RAG agent details
  getRAGAgentDetails: async (agentId) => {
    const response = await apiClient.get(`/rag-agents/${agentId}`);
    return response.data;
  },

  // Update RAG agent (fine-tuning)
  updateRAGAgent: async (agentId, updates) => {
    const response = await apiClient.put(`/rag-agents/${agentId}`, updates);
    return response.data;
  }
};

// Constants for dropdowns and filtering
export const INCIDENT_PRIORITIES = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

export const INCIDENT_STATUSES = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING_VALIDATION: 'PENDING_VALIDATION',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED'
};

export const INCIDENT_CATEGORIES = {
  SERVER_DOWNTIME: 'SERVER_DOWNTIME',
  DATABASE_ISSUE: 'DATABASE_ISSUE',
  APPLICATION_ERROR: 'APPLICATION_ERROR',
  NETWORK_CONNECTIVITY: 'NETWORK_CONNECTIVITY',
  PERFORMANCE_DEGRADATION: 'PERFORMANCE_DEGRADATION',
  SECURITY_INCIDENT: 'SECURITY_INCIDENT',
  CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',
  HARDWARE_FAILURE: 'HARDWARE_FAILURE'
};

export const CATEGORY_LABELS = {
  [INCIDENT_CATEGORIES.SERVER_DOWNTIME]: 'Server Downtime',
  [INCIDENT_CATEGORIES.DATABASE_ISSUE]: 'Database Issue',
  [INCIDENT_CATEGORIES.APPLICATION_ERROR]: 'Application Error',
  [INCIDENT_CATEGORIES.NETWORK_CONNECTIVITY]: 'Network Connectivity',
  [INCIDENT_CATEGORIES.PERFORMANCE_DEGRADATION]: 'Performance Degradation',
  [INCIDENT_CATEGORIES.SECURITY_INCIDENT]: 'Security Incident',
  [INCIDENT_CATEGORIES.CONFIGURATION_ERROR]: 'Configuration Error',
  [INCIDENT_CATEGORIES.HARDWARE_FAILURE]: 'Hardware Failure'
};